import { Vehicle } from '../../vehicle/Vehicle';
import { BodyTypes } from '../../LevelManager';
import EntityContainer from './EntityContainer';
import { Driver } from '../../vehicle/Vehicle';
import { VehicleVillain } from '../../vehicle/VehicleVillain';

export default abstract class EntityMoney extends EntityContainer {
  protected hasCollided: boolean;
  protected boundsExtension: number;

  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y);

    this.hasCollided = false;
    this.boundsExtension = 0;
  }

  public canCollect(Vehicle: Vehicle): boolean {
    return true;
  }

  public collect(Vehicle: Vehicle) {
    this.score(Vehicle);

    // Ensure money is in front after being picked up.
    this.setDepth(9999);

    this.scene?.tweens?.killTweensOf(this);
    this.scene.add.tween({
      targets: this,
      y: '+=-150',
      alpha: { from: 1, to: 0, duration: 1000 },
      duration: 400,
      ease: Phaser.Math.Easing.Cubic.Out,
      onComplete: this.recycle,
      onCompleteParams: [true],
      onCompleteScope: this,
    });

    this.hasCollided = true;
  }

  public recycle() {
    this.scene?.tweens?.killTweensOf(this);
    this.setVisible(false);
    this.setActive(false);
    this.setPosition(-1000, 0);
  }

  protected injectMatter(target: Phaser.GameObjects.GameObject, boundsX: number, boundsY: number, width: number, height: number) {
    let origX = this.x;
    let origY = this.y;

    let matterShape = this.scene.matter.bodies.rectangle(boundsX, boundsY, width, height, {
      isStatic: true,
      isSensor: true,
      onCollideCallback: this.onCollision.bind(this)
    });

    let matterSprite = this.scene.matter.add.gameObject(target, matterShape) as Phaser.Physics.Matter.Sprite;

    this.scene.matter.body.setPosition(target.body as MatterJS.BodyType, this.scene.matter.vector.create(origX, origY));
    this.scene.matter.setVelocity(target.body as MatterJS.BodyType, 0, 0);
  }

  protected onCollision(pair: MatterJS.ICollisionPair) {
    if (this.hasCollided) return;

    if ((pair.bodyA as MatterJS.BodyType).label == BodyTypes.Vehicle) {
      this.onVehicleCollision(pair, pair.bodyA as MatterJS.BodyType, pair.bodyB as MatterJS.BodyType);
    } else if ((pair.bodyB as MatterJS.BodyType).label == BodyTypes.Vehicle) {
      this.onVehicleCollision(pair, pair.bodyB as MatterJS.BodyType, pair.bodyA as MatterJS.BodyType);
    }
  }

  protected onVehicleCollision(pair: MatterJS.ICollisionPair, vehicle: MatterJS.BodyType, money: MatterJS.BodyType) {
    if (vehicle.gameObject instanceof Vehicle && vehicle.gameObject.DriverProfile.driverTeam == Driver.Hero && this.canCollect(vehicle.gameObject)) {
      this.collect(vehicle.gameObject);
    }
  }

  public throwTo(vehicle: VehicleVillain, money: Phaser.GameObjects.Image, shadow: Phaser.GameObjects.Image) {
    let groundX = vehicle.x;
    let depthY = vehicle.y;
    let groundY = money.y;

    let throwDistance = 20;

    let throwHeight = 150;

    // Ensure money is in front before landing.
    // this.setDepth(9999);

    this.x = vehicle.x + vehicle.MoneySpawnOffsetX;
    this.y = vehicle.y + vehicle.MoneyOffsetY;
    money.y += vehicle.MoneySpawnOffsetY + vehicle.MoneyOffsetY;

    let tween = this.scene.add.tween({
      targets: this,
      x: vehicle.x + (throwDistance * vehicle.CurrentSpeedX),
      duration: 1000,
      ease: Phaser.Math.Easing.Linear,
      // onUpdate: (tween, target) => {
      //   let diff = vehicle.x - groundX;
      //   // tween.updateTo('x', vehicle.x, true);
      // }
      onComplete: () => {
        this.setDepth(depthY);
      }
    });

    this.scene.add.tween({
      targets: money,
      y: money.y - throwHeight,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    this.scene.add.tween({
      targets: shadow,
      scale: 0.5,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    this.scene.add.tween({
      targets: money,
      y: groundY,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.In,
      delay: 500
    });

    this.scene.add.tween({
      targets: shadow,
      scale: 1,
      duration: 500,
      ease: Phaser.Math.Easing.Cubic.In,
      delay: 500
    });
  }

  public releaseTo(vehicle: VehicleVillain, money: Phaser.GameObjects.Image) {
    let riseHeight = 100;

    this.x = vehicle.x + vehicle.MoneySpawnOffsetX;
    this.y = vehicle.y + vehicle.MoneySpawnOffsetY;
    // money.y -= vehicle.MoneySpawnOffsetY;
    money.scaleX = money.scaleY = 0.25;
    money.rotation = Math.PI * 1.5;

    this.scene.add.tween({
      targets: money,
      scaleX: 1,
      scaleY: 1,
      rotation: { value: 0, duration: 750, ease: Phaser.Math.Easing.Cubic.Out },
      duration: 1000,
      ease: Phaser.Math.Easing.Cubic.Out
    });

    // this.scene.add.tween({
    //   targets: money,
    //   y: money.y + vehicle.MoneySpawnOffsetY,
    //   duration: 500,
    //   ease: Phaser.Math.Easing.Cubic.Out
    // });

    this.scene.add.tween({
      targets: this,
      y: this.y + -100,
      duration: 3000,
      ease: Phaser.Math.Easing.Cubic.Out
    });
  }

  public abstract dropMoney(vehicle: VehicleVillain): void;

  protected abstract score(vehicle : Vehicle): void;
}
